import { render, staticRenderFns } from "./Renew.vue?vue&type=template&id=0a3e2bde"
import script from "./Renew.js?vue&type=script&lang=js&external"
export * from "./Renew.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports